import styled from 'styled-components';
import Image from '@stencil/image';

export const WhyIndianBookWrapper = styled.div`
  background: #ffffff;
  border-radius: 1.2rem;
  padding: 2.4rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  max-width: 120rem;
  margin-bottom: 2.4rem;
  border: 1px solid #e5edf6;
`;

export const WhyIndianBookHeading = styled.div(
  props => `
  display: flex;
  align-items: center;
  h3 {
    font-weight: 600;
    font-size: 2.2rem;
    color: #141823;
  }
  span {
    margin-left: 0.8rem;
  }
`,
);

export const WhyIndianBookReasons = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 2.5rem;
  li {
    display: flex;
    width: 100%;
    margin-bottom: 2.2rem;
    :last-child {
      margin-bottom: 0;
    }
    div {
      display: flex;
      font-size: 16px;
      color: #141823;
      .title {
        font-weight: 600;
      }
    }
    .reasonIcon {
      margin-right: 0.8rem;
      display: flex;
      align-items: center;
      width: 2.2rem;
    }
  }
`;

export const ViewAllBtn = styled.span`
  font-size: ${props => props.theme.font.custom(14)};
  color: ${props => props.theme.colors.goBrandBlue.base};
  display: flex;
  align-items: baseline;
  font-weight: 600;
  cursor: pointer;
`;

export const IndianFlagIconStyled = styled(Image)(
  props => `
    height: 1.9rem;
    object-fit: fill;
    vertical-align: middle;
    margin-bottom: .4rem;
    `,
);

export const ImageIconStyled = styled(Image)(
  props => `
    height:2.2rem;
    width:2.2rem;
    object-fit: fill;
    `,
);
